import { render, staticRenderFns } from "./ResponsiveRowSwitch.vue?vue&type=template&id=11002a99"
import script from "./ResponsiveRowSwitch.vue?vue&type=script&lang=ts"
export * from "./ResponsiveRowSwitch.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports